<template>
  <main class="blog" :class="{ 'blog--reading': this.post }">
    <blog-nav :content="content" :filters="filters" :navs="navs" />

    <ul class="blog__feed">
      <li>
        <div class="desc">
          <p>Culturally, historically, or aesthetically significant typewriters, for sale or restoration.</p>(And don't you just love the sound a typewriter makes? It gives your writing its own soundtrack!)
          <br />
          <br />
          <p>
            --
            <br />Follow us on social:
            <br />
            <a href="https://www.ebay.com/usr/iconictypewriters">eBay</a>,
            <a href="https://www.instagram.com/iconictypewriters">Instagram</a>,
            <a href="https://www.youtube.com/iconictypewriters">YouTube</a>,
            <a href="https://www.facebook.com/iconictypewriters">Facebook</a>, and
            <a href="https://www.twitter.com/Typewrite_rs">Twitter</a>
          </p>
          <br />
          <p>
            Or simply drop us a line:
            <br />
            <a href="mailto:desk@typewrite.rs?subject=Hello">desk@typewrite.rs</a>
          </p>
        </div>
      </li>
    </ul>

    <blog-footer />
  </main>
</template>

<script>
import BlogNav from "./BlogNav";
import BlogFooter from "./BlogFooter";

export default {
  name: "blog",
  components: { BlogNav, BlogFooter },
  resource: "Blog",
  props: {
    post: String,
    author: String
  },

  data() {
    return {
      navs: 0,
      title: "",
      labels: {
        post: "",
        author: ""
      }
    };
  },

  computed: {
    content() {
      return { title: this.title, labels: this.labels };
    },
    filters() {
      let filters = {};

      if (this.post) filters.post = this.post;
      if (this.author) filters.author = this.author;

      return filters;
    }
  },

  watch: {
    "$route.name"(to, from) {
      if (to !== from) this.navs++;
    }
  },

  mounted() {
    this.$getResource("blog").then(x => {
      // use pace hook to know when rendering is ready
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/About.vue